<template>
  <div>
     <yd-icon name="home" size=".6rem" color="#FF685D"></yd-icon>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue